import { StorageService } from 'src/app/_services/storage.service';
import { AttachedFilesModule } from '../../../_models/attached-files-module.model';
import { AttachedFilesService } from '../../../_services/attached-files.service';
import { EncryptionService } from '../../../_services/encryption.service';
import { StateMaster } from '../../../_models/state-master.model';
import { StateMasterService } from '../../../_services/state-master.service';
import { HistoricStatesModule } from '../../../_models/historic-states.model';
import { Router } from '@angular/router';
import { ClaimOperationCPService } from '../../../_services/claim-operation-cp.service';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ClaimOperationCP } from '../../../_models/claim-operation-cp.model';
import { BaseComponent } from 'src/app/common/base/base.component';
import { LanguageManagerService } from 'src/app/_services/languagemanager.service';
import { ActivatedRoute } from '@angular/router';
import { StateTransitionsService } from 'src/app/_services/state-transitions.service';
import { EmailsService } from 'src/app/_services/emails.service';
import { StateTransitionsModel } from 'src/app/_models/state-transitions.model';
import { CurrencyCode } from 'src/app/_enums/currency-code';
import { Emails } from 'src/app/_models/emails.model';
import { SafeHtml, DomSanitizer } from '@angular/platform-browser';
import { ClaimDisputesService } from 'src/app/_services/claim-disputes.service';
import { ClaimDisputesDTO } from 'src/app/_models/ClaimDisputesDTO.model';
import { HistoricStatesDTO } from 'src/app/_models/historicStatesDTO.model';
import { environment } from 'src/environments/environment';
import { CountStates } from 'src/app/_models/count-states.model';

@Component({
  selector: 'DCO-claim-client-edit',
  templateUrl: './dispute-details.component.html',
  standalone: false,
})
export class DisputeDetailsComponent extends BaseComponent implements OnInit {
  @ViewChild('changeFileModal') changeFileModal: ElementRef;

  allowHelp = environment.allowHelp;
  currentFormats: any;
  confirmDispute: number = 0;
  stateMasterId: number = 0;
  attachedFilesInfo: AttachedFilesModule[];
  claimOperations: ClaimOperationCP[];
  stateName: string;
  historicStates: HistoricStatesDTO[] = [];
  Email: Emails;
  stateTransitionsRes: StateTransitionsModel[] = [];
  transitionsLoaded = false;
  states: CountStates[];
  statesGet: StateMaster[];
  statefilter: string = '';
  claimId: string = '';
  claimOperationId: string = '';
  claimOperationIdAndClaimId: string = '';
  idsDecrypt: string;
  lstIdsDecrypt: string[];
  date = new Date();
  dueDateF: number = 0;
  lastUpdate = new Date();
  emailText: SafeHtml;
  fromAddress: string;
  toWhom: string;
  subject: string;
  claimDisputes: ClaimDisputesDTO[];
  tabName: string;
  openIndex: number | null = null;

  page = 1;

  today: any =
    this.date.getDate() +
    '/' +
    (this.date.getMonth() + 1) +
    '/' +
    this.date.getFullYear();

  // select1: string;

  parameters: any = {
    search: [],
    top: 0,
    order:   {by: 'ClaimOperationID',
  ordering: 'DESC' },
    boolOperator: "AND"
  };

  constructor(
    private ClaimOperationCP: ClaimOperationCPService,
    public override router: Router,
    public override langService: LanguageManagerService,
    private StateMasterService: StateMasterService,
    private EncryptionService: EncryptionService,
    private AttachedFilesService: AttachedFilesService,
    private route: ActivatedRoute,
    private StateTransitionsService: StateTransitionsService,
    private EmailsService: EmailsService,
    private StorageService: StorageService,
    private sanitizer: DomSanitizer,
    private ClaimDisputesService: ClaimDisputesService
  ) {
    super(router, langService, route);
  }

  toggleAccordion(index: number) {
  this.openIndex = this.openIndex === index ? null : index;
}

  override ngOnInit(): void {
    super.ngOnInit();
    this.currentFormats =
      this.langService.dateAndCurrencyChangeFormat$.subscribe((formats) => {
        this.currentFormats = formats; // Guardamos los formatos actualizados para utilizarlos
      });
    const currentLanguage = this.langService.GetCurrentLanguage();
    this.langService.updateFormats(currentLanguage); // Cargar los formatos iniciales

    this.route.queryParams.subscribe(params => {
      this.tabName = params['tab'];
    });

    this.StateMasterService.GetCountStates().subscribe(
      (state) => {
        this.states = state;
      }
    );

    //Recuperar ids encriptadas
    this.claimOperationIdAndClaimId = this.EncryptionService.decode(
      this.route.snapshot.params['id']
    );
    this.idsDecrypt = this.EncryptionService.decrypt(
      this.claimOperationIdAndClaimId
    );
    this.lstIdsDecrypt = this.idsDecrypt.split('-');
    this.claimOperationId = this.lstIdsDecrypt[1];
    this.claimId = this.lstIdsDecrypt[0];
    //console.log("claim id en parent " + this.claimId)
    /*this.parameters.search =
      'claimoperationid=' +
      this.claimOperationId +
      ' and ' +
      'co.claimid=' +
      this.claimId;*/

      const filterClaimOp = {
        identifier: "ClaimOperationID",
        value: this.claimOperationId,
        type: 'int',
        operator: "="
      };

      const filterClaim = {
        identifier: "ClaimID",
        value: this.claimId,
        type: 'int',
        operator: "="
      };

      if (!Array.isArray(this.parameters.search)) {
        this.parameters.search = [];
      }


    this.parameters.search.push(filterClaim, filterClaimOp);


    this.ClaimDisputesService.GetDisputes(this.claimOperationId).subscribe({
      next: (response) => {
        this.claimDisputes = response;
        //console.log(this.claimDisputes);
      },
      
      complete() { },
    });

    this.ClaimOperationCP.ClaimOperations_Get(this.parameters).subscribe(
      (res) => {
        this.claimOperations = res.data;
        this.StateMasterService.GetCountStates().subscribe(
          (state) => {
            this.states = state;
            
            this.claimOperations.forEach(element => {
              const stateMaster = this.states.find(
                s => s.listStateMasterId.includes(element.state) 
              );
              this.stateName = stateMaster.stateGroup;
            });
          },
          (error) => {
            if (error.status == 401) {
            }
          }
        );


        //console.log(this.claimOperations);
        const today = new Date();

        let fechaFin = new Date(this.claimOperations[0].dateLimit);

        const diferenciaEnMilisegundos = fechaFin.getTime() - today.getTime();

        const diasDiferencia = Math.ceil(
          diferenciaEnMilisegundos / (1000 * 60 * 60 * 24)
        ); // 1000 ms, 60 s, 60 min, 24 h
        if (diasDiferencia >= 0) {
          this.dueDateF = diasDiferencia;
        } else {
          this.dueDateF = 0;
        }

        //console.log('duedateF', this.dueDateF)

        this.ClaimOperationCP.GetClaimOperationHistoricState(
          this.claimId,
          this.claimOperationId
        ).subscribe(
          (historic) => {
            this.historicStates = historic;
            this.stateMasterId = this.claimOperations[0].state;

            this.StateMasterService.Get().subscribe(
              (state) => {
                this.statesGet = state;

                this.historicStates.forEach(element => {
                  const stateMaster = this.statesGet.find(
                    s => s.stateMasterID === element.stateMasterId
                  );
                  element.stateName = stateMaster.name;
                });
              },
              (error) => {
                if (error.status == 401) {
                }
              }
            );




            this.lastUpdate = this.historicStates.reduce((mayor, item) => {
              const fechaActual = new Date(item.startDate);
              return fechaActual > mayor ? fechaActual : mayor;
            }, new Date(0));
            //console.log('lastUpdate', this.lastUpdate);

            this.StateTransitionsService.getStateTransitions(
              this.stateMasterId
            ).subscribe(
              (res) => {
                this.stateTransitionsRes = res;
                this.transitionsLoaded = true;
                //console.log(this.stateMasterId)
                //console.log(this.stateTransitionsRes)
              },
              (error) => {
                //console.log(error);
              }
            );
          },
          (error) => {
            if (error.status == 401) {
            }
          }
        );
      },
      (error) => {
        if (error.status == 401) {
        }
      }
    );

    this.StateMasterService.Get().subscribe(
      (state) => {
        this.statesGet = state;
        //console.log('estados', this.states)
      },
      (error) => {
        if (error.status == 401) {
        }
      }
    );
  }


  GetStatusByDueDate() {
    if (this.dueDateF <= 2) {
      return 'text-danger';
    } else if (this.dueDateF <= 10 && this.dueDateF > 2) {
      return 'text-warning';
    }
    return 'text-success';
  }

  GoBack() {
    this.router.navigate(['/disputes'],
      {
        queryParams: { tab: this.tabName }
      }
    );
  }

  receiveDynamicFormComfirmation($event) {
    this.confirmDispute = $event;
  }

  getCurrencyCode(disputeCurrency: string): string {
    return this.langService.translate("@@CMP.ClaimDetails_Currency" + disputeCurrency);
  }

  openEmailModal(emailId: number) {
    this.EmailsService.getEmailsByClaimId(emailId).subscribe(
      (resp) => {
        this.Email = resp;
        this.emailText = this.sanitizer.bypassSecurityTrustHtml(
          this.Email.body
        );

        this.fromAddress = this.Email.fromAddress;
        this.toWhom = this.Email.toWhom;
        this.subject = this.Email.subject;

        jQuery(this.changeFileModal.nativeElement).modal('show');
      },
      (error) => {
        if (error.status == 401) {
        }
      }
    );
  }

  // Cerrar y limpiar modal
  closeModal(): void {
    this.clearFormModal();

    jQuery(this.changeFileModal.nativeElement).modal('hide');
  }

  // Limpia campos de formulario del modal
  clearFormModal(): void { }
}
